import { Provider } from '@angular/core';

import { TenantAwareTranslationService } from './tenant-aware-translation.service';

/**
 * Provides the TenantAwareTranslationService for use in the Angular application.
 * This service wraps LocaleService and applies tenant-specific translations.
 *
 * Usage in a component:
 * ```typescript
 * import { TenantAwareTranslationService } from 'src/app/shared/services/tenant-aware-translation.service';
 *
 * export class MyComponent {
 *   constructor(private tenantTranslation: TenantAwareTranslationService) {}
 *
 *   translateWithTenant(key: string): string {
 *     return this.tenantTranslation.translate(key);
 *   }
 * }
 * ```
 */
export function provideTenantAwareTranslation(): Provider[] {
  return [TenantAwareTranslationService];
}
